import React from 'react';
import 'CSS/demand-supply/demand-supply.scss';
import 'CSS/dashboard-statistic.scss';
import 'CSS/dashboard-tickets.scss';
import 'CSS/dashboard-slips.scss';
import Grid from '@material-ui/core/Grid';

import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import { Select, MenuItem } from '@material-ui/core';

export const AddQuantities = ({
  handleChange,
  handleBlur,
  quantities,
  errors,
  touched,
  unit,
}) => {
  return (
    <Grid item xs={6} className="">
      <Grid container>
        <Grid item xs={6} className="">
          <h2 className="t-primary-16 t-weight-b u-mrg-bot-10 u-mrg-top-10">
            Quantity
          </h2>
        </Grid>
        <Grid container className="t-primary-14 c-gray-light">
          <FormControl className="u-mrg-left-5 u-mrg-r-5">
            <InputLabel
              classes={{
                root: 'label--c-gray',
              }}
            >
              Quantity
            </InputLabel>
            {quantities !== undefined ? (
              <Input
                name="quantityValue"
                onChange={handleChange}
                onBlur={handleBlur}
                value={quantities}
                error={!!(errors.quantities && touched.quantities)}
                classes={{
                  underline: 'underline--c-black',
                }}
              />
            ) : null}
            {errors.quantityValue && touched.quantityValue && (
              <FormHelperText error>{errors.quantityValue}</FormHelperText>
            )}
          </FormControl>
          <FormControl className="u-mrg-left-5 u-mrg-r-5">
            <InputLabel
              classes={{
                root: 'label--c-gray',
              }}
            >
              Unit
            </InputLabel>
            {unit !== undefined ? (
              <Select
                value={unit}
                onChange={handleChange}
                inputProps={{
                  name: 'quantityUnit',
                  id: 'quantityUnit',
                  underline: 'underline--c-black',
                }}
              >
                <MenuItem value={'luminaires'}>luminaires</MenuItem>
                <MenuItem value={'linear metres'}>linear metres</MenuItem>
                <MenuItem value={'linear feet'}>linear feet</MenuItem>
              </Select>
            ) : null}
            {errors.quantityUnit && touched.quantityUnit && (
              <FormHelperText error>{errors.quantityUnit}</FormHelperText>
            )}
          </FormControl>
        </Grid>
      </Grid>
    </Grid>
  );
};
